import styled from 'styled-components';

import { QuizBlockRoot } from './quizBlock.styles';

export const ChartRoot = styled(QuizBlockRoot)`
  .chart-goal-date {
    margin: -6px 0 16px;
    color: var(--quiz-accent, var(--quiz-accent-fallback));
    font-size: 24px;
    font-weight: 800;
    text-align: center;
  }

  .chart-card {
    padding: 12px 10px 6px;
  }

  .chart-svg {
    display: block;
    width: 100%;
    height: auto;
    overflow: visible;
  }

  .chart-grid {
    stroke: rgba(15, 23, 42, 0.08);
    stroke-dasharray: 4 4;
  }

  .chart-line {
    fill: none;
    stroke: var(--quiz-accent, var(--quiz-accent-fallback));
    stroke-width: 4;
    stroke-linecap: round;
    stroke-dasharray: 600;
    stroke-dashoffset: 600;
    animation: chart-draw 1.4s cubic-bezier(0.22, 1, 0.36, 1) 0.15s forwards;
  }

  .chart-area-stop {
    stop-color: var(--quiz-accent, var(--quiz-accent-fallback));
  }

  .chart-area {
    opacity: 0;
    animation: chart-fade 0.8s ease 0.9s forwards;
  }

  .chart-dot-start {
    fill: #ffffff;
    stroke: #ef4444;
    stroke-width: 4;
  }

  .chart-dot-goal {
    fill: #ffffff;
    stroke: var(--quiz-accent, var(--quiz-accent-fallback));
    stroke-width: 4;
    opacity: 0;
    animation: chart-fade 0.3s ease 1.4s forwards;
  }

  .chart-badge rect {
    fill: #111827;
  }

  .chart-badge text {
    fill: #ffffff;
    font-size: 11px;
    font-weight: 700;
  }

  .chart-badge.is-goal rect {
    fill: var(--quiz-accent, var(--quiz-accent-fallback));
  }

  .chart-badge.is-goal {
    opacity: 0;
    animation: chart-fade 0.3s ease 1.5s forwards;
  }

  .chart-tick {
    fill: currentColor;
    font-size: 10.5px;
    opacity: 0.6;
  }

  .chart-footnote {
    margin: 10px 4px 0;
    font-size: 11.5px;
    text-align: center;
    opacity: 0.6;
  }

  @keyframes chart-draw {
    to {
      stroke-dashoffset: 0;
    }
  }

  @keyframes chart-fade {
    to {
      opacity: 1;
    }
  }
`;
